import type { MotiTransitionProp } from "moti";
export const spring: MotiTransitionProp = {
  type: "spring",
  mass: 1,
  stiffness: 260,
  damping: 18,
  overshootClamping: false
};

// Time in ms Standard delays for animation sync presentations used in the get
// started context
// "Stagger" is the delay between each line
// "Delay" is the delay of the start of the first line
export const LOGO_DELAY = 300;
export const LINE_DELAY = 200;
export const LINE_STAGGER = 400;
export const BUBBLE_STAGGER = 100;
export const BUBBLE_DELAY = 1000;